import { render } from "./unavailable.vue?vue&type=template&id=71fa8cf8"
import script from "./unavailable.vue?vue&type=script&lang=js"
export * from "./unavailable.vue?vue&type=script&lang=js"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__